const FeedbackData = [
	{
		id: 1,
		rating: 10,
		text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae amet distinctio in assumenda a. Dicta deserunt qui in quod adipisci dignissimos accusamus nostrum, inventore quaerat excepturi fugiat nam, dolores natus.",
	},
	{
		id: 2,
		rating: 7,
		text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae amet distinctio in assumenda a. Dicta deserunt qui in quod adipisci dignissimos accusamus nostrum, inventore quaerat excepturi fugiat nam, dolores natus.",
	},
	{
		id: 3,
		rating: 9,
		text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae amet distinctio in assumenda a. Dicta deserunt qui in quod adipisci dignissimos accusamus nostrum, inventore quaerat excepturi fugiat nam, dolores natus.",
	},
];

export default FeedbackData;